export default __webpack_public_path__ + "static/media/icon-msg-good.402a4758.svg";